import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAuthOrg } from '../context/AuthOrgContext';

const PrivateRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { isAuthenticated: isOrgAuthenticated } = useAuthOrg();
  return isAuthenticated || isOrgAuthenticated ? <Outlet /> : <Navigate to="/logout" replace />;
};

export default PrivateRoute;